import { z } from 'zod';
import { timezones } from '../timezones';
import {
  PASSWORD_COMPLEXITY_MESSAGE,
  securePasswordRegex,
} from './securePasswordSchemas';

export const MIN_USER_PASSWORD_LENGTH = 8;
export const MAX_USER_PASSWORD_LENGTH = 200;
export const MAX_USERNAME_LENGTH = 200;

export const secureUserSchemas = {
  timezone: z.enum(timezones),
  password: z
    .string()
    .regex(securePasswordRegex, PASSWORD_COMPLEXITY_MESSAGE)
    .min(MIN_USER_PASSWORD_LENGTH)
    .max(MAX_USER_PASSWORD_LENGTH),
  username: z
    .string()
    .min(1)
    .regex(/^[a-zA-Z0-9_\-.@]+$/)
    .max(MAX_USERNAME_LENGTH),
  roleIds: z.array(z.string()),
};
